import * as bookmarks from './bookmarks'
import * as support from './support'
import * as experts from './experts'
import * as relatives from './relatives'
import * as vendors from './vendors'
import * as chatgroups from './chatgroups'
import * as speaker from './speaker'
import * as tags from './tags'
import * as chatmetrics from './chatmetrics'
import * as subscription from './subscription'

export default {
  bookmarks,
  support,
  experts,
  relatives,
  vendors,
  chatgroups,
  speaker,
  tags,
  chatmetrics,
  subscription,
}
